$(function() {

   // Listen for variant selection change & subsequent price update
   document.addEventListener('variantPriceChangeUnitPrice', function (e) {

      // Base vars
      let outputTarget = $('.template-product .product__price');
      let unitSize = 0;
      let perUnitPrice = 0;
      let currentPrice = 0;

      if(e.detail.variant.textPrice) {
         currentPrice = parseFloat(e.detail.variant.price.replace(/\D/g,'')) / 100;
      } else {
         currentPrice = parseFloat(e.detail.variant.price / 100);
      }

      // Obtain unit count
      unitSize = e.detail.variant.title.split('-')[0];
      unitSize = parseInt(unitSize.replace('-', ''));

      // Calculate per unit cost
      perUnitPrice = parseFloat(currentPrice / unitSize).toFixed('2');

      // Output per unit price
      outputTarget.append('<span class="per-unit-price">($'+ perUnitPrice +'/unit)</span>')

   });

   // Calculate per unit price on page load
   document.dispatchEvent(new CustomEvent('variantPriceChangeUnitPrice', {
      detail: {
         variant: {
            'title': $('.variant-input input[type="radio"]:checked').val(),
            'price': $('[data-product-price]').text(),
            'textPrice': true
         }
      }
   }));


});